import Vue from "vue";

const state = {
  date: null,
  data: {},
  inStates: [],

  initialised: false,
};

const getters = {
  getPublicHolidayByAddress: (state) => (address) => {
    if (address && address.state && state.data[address.state]) {
      return {
        name: state.data[address.state],
        inStates: state.inStates,
      };
    }

    return null;
  },
};

/* eslint-disable no-shadow, no-param-reassign, arrow-body-style */
const actions = {
  initialise: async ({ state }, date) => {
    const response = await Vue.http.get(`/public-holidays?search=date:${date}`);
    const { data } = response.body;
    state.date = date;
    state.data = {};
    state.inStates = [];

    if (data && data.length) {
      data.forEach((holiday) => {
        state.data[holiday.state] = holiday.name;
        state.inStates.push(holiday.state);
      });
    }

    if (state.inStates.length === 8) {
      state.inStates = "across Australia";
    } else {
      state.inStates = "in " + state.inStates.join(", ");
    }

    state.initialised = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
};
